import { parseServerTimestampMs } from './serverTimestamp';

/** "9:05 AM" for when a call started; '' when unknown or unparseable. A naive timestamp is UTC. */
export const formatStartTime = (timestamp?: string | null): string => {
  const startedAtMs = parseServerTimestampMs(timestamp);
  if (startedAtMs === null) return '';
  return new Date(startedAtMs).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
};
